import { api as orderApi } from './order';
import { api as printerApi } from './printer';
import { api as menuAvailabilityApi } from './menuAvailability';
export * from './order';
export * from './menuAvailability';
export { init } from './client';

export const api = {
  ...orderApi,
  ...printerApi,
  ...menuAvailabilityApi,
};
